import type { ComponentType, CSSProperties, ReactNode } from 'react';
import { IcoChevron } from './iconos';

/**
 * Un grupo del panel lateral (lado.css): la cabecera con su ícono, que lo pliega o lo abre, y
 * lo de adentro. Es el mismo del appliance (Ajustes, filtros de Equipos, mapas del Diagrama),
 * para que la app se sienta una sola.
 */
export function GrupoLado({
  id,
  titulo,
  aux,
  Ico,
  n,
  abierto,
  aqui = false,
  alTocar,
  accion,
  orden = 0,
  className = '',
  children,
}: {
  id: string;
  titulo: string;
  /** Un dato chico al lado del título (ej. "3 fuera de este mapa"). */
  aux?: ReactNode;
  Ico: ComponentType<{ className?: string }>;
  /** Cuántas cosas tiene: se ve cuando está plegado. */
  n?: number;
  abierto: boolean;
  /** El grupo donde se está: su ícono se enciende. */
  aqui?: boolean;
  alTocar: () => void;
  /** Un botón al lado de la cabecera (ej. "+ Mapa"): hermano, no adentro del botón que pliega. */
  accion?: ReactNode;
  /** Para escalonar la entrada de los grupos. */
  orden?: number;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={`lado-grupo${abierto ? ' abierto' : ''}${aqui ? ' aqui' : ''} ${className}`} style={{ '--i': orden } as CSSProperties}>
      <div className="lado-fila">
        <button type="button" className="lado-cab" aria-expanded={abierto} aria-controls={`lado-${id}`} onClick={alTocar}>
          <Ico className="lado-ico" />
          <span>
            {titulo}
            {aux && <small>{aux}</small>}
          </span>
          {!abierto && n !== undefined && <small className="lado-n">{n}</small>}
          <IcoChevron className="lado-flecha" />
        </button>
        {accion}
      </div>
      <div id={`lado-${id}`} className="lado-lista" hidden={!abierto}>
        <div>{children}</div>
      </div>
    </div>
  );
}
